export default "__VITE_ASSET__DQKxRCeP__"